import { IconButton, TableCell, Dialog } from '@mui/material';
import styled from 'styled-components';
import { COLORS } from 'theme/colors';

export const ActionsContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0.1rem;
  color: ${COLORS.DARK_BLUE};
  padding-right: 0.75rem;
`;

export const StyledIconButton = styled(IconButton)`
  height: 30px;
  width: 30px;
  &&:hover {
    color: ${COLORS.BLUE};
  }
`;

export const StyledTableFooterCell = styled(TableCell)`
  font-weight: 600;
  font-size: 0.85rem;
  color: black;
  width: min-content;
  padding: 12px;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: center;
`;

export const StyledDialog = styled(Dialog)<{ align?: string }>`
  && .MuiDialog-paper {
    margin: 1rem 2rem;
    max-height: 99vh;
    align-self: ${(props) => (props.align ? props.align : `center`)};
  }

  && .MuiDialogTitle-root {
    padding: 0.65rem 1rem;
    font-weight: 600;
  }

  && .MuiDialogContent-root {
    padding: 1rem 1.5rem;
    min-width: 600px;
    max-width: 100%;

    && .MuiTextField-root {
      width: 100%;
      padding: 5rem;
    }
  }
  && .MuiDialogActions-root {
    padding: 0.75rem 1.5rem;
  }
`;

export const InvoiceNetValueContainer = styled.p`
  text-align: right;
  padding: 0.5rem 1rem;
  /* font-size: 0.9rem; */
`;
